import { render, staticRenderFns } from "./EvaluatorsTab.vue?vue&type=template&id=1527cf01&scoped=true"
import script from "./EvaluatorsTab.vue?vue&type=script&lang=js"
export * from "./EvaluatorsTab.vue?vue&type=script&lang=js"
import style0 from "./EvaluatorsTab.vue?vue&type=style&index=0&id=1527cf01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527cf01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1527cf01')) {
      api.createRecord('1527cf01', component.options)
    } else {
      api.reload('1527cf01', component.options)
    }
    module.hot.accept("./EvaluatorsTab.vue?vue&type=template&id=1527cf01&scoped=true", function () {
      api.rerender('1527cf01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/EvaluatorsTab.vue"
export default component.exports